import { render } from "./WCSideBarV2.vue?vue&type=template&id=2c1281ea&scoped=true"
import script from "./WCSideBarV2.vue?vue&type=script&lang=js"
export * from "./WCSideBarV2.vue?vue&type=script&lang=js"

import "./WCSideBarV2.vue?vue&type=style&index=0&id=2c1281ea&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1281ea"]])

export default __exports__